import * as React from 'react'
import { useActions as useUtilitiesActions } from '../../../../context/reports/utilities/useActions'
import { orderByEvent, timeFrameEvent } from '../../../../utils/eventTracking'
import { TRACKING_EVENT_ORDER_BY, TRACKING_EVENT_TIME_FRAME } from '../../../../context/reports/utilities/constants'
import { Sorting } from '../../../../context/reports/types'
import { TimeFrame } from '../../../../context/reports/utilities/types'

export function useTrackedActions () {
  const {
    setRankedSitesSortingDirection,
    setRankedYearsSortingDirection,
    setTimeFrame
  } = useUtilitiesActions()

  const trackedRankedSitesOrderBy = React.useCallback(function trackedOrderBy (chartTitle: string) {
    return (value: Sorting) => {
      const chartOrder = value === 'asc' ? 'least to most' : 'most to least'
      orderByEvent({
        chartTitle,
        chartOrder
      }, TRACKING_EVENT_ORDER_BY)
      setRankedSitesSortingDirection(value)
    }
  }, [])

  const trackedRankedYearsOrderBy = React.useCallback(function trackedOrderBy (chartTitle: string) {
    return (value: Sorting) => {
      const chartOrder = value === 'asc' ? 'least to most' : 'most to least'
      orderByEvent({
        chartTitle,
        chartOrder
      }, TRACKING_EVENT_ORDER_BY)
      setRankedYearsSortingDirection(value)
    }
  }, [])

  const trackedTimeFrame = React.useCallback(function trackedTimeFrame (
    timeFrameOption: TimeFrame,
    startDate: string,
    endDate: string
  ) {
    timeFrameEvent({ timeFrameOption }, TRACKING_EVENT_TIME_FRAME)
    setTimeFrame(timeFrameOption, startDate, endDate)
  }, [])

  return {
    trackedRankedSitesOrderBy,
    trackedRankedYearsOrderBy,
    trackedTimeFrame
  }
}
